/* Para onde voltar depois de entrar no Central (?next=/caminho). A pagina publica de tutoriais manda a vendedora ao login com
   "?next=/tutoriais/..." e, depois de entrar, ela volta para la. O valor vem da URL (quem digita e o navegador de qualquer pessoa),
   entao SO vale caminho RELATIVO INTERNO: comeca com uma unica "/", sem host, sem esquema, sem barra invertida, sem caractere de
   controle. Qualquer outra coisa ("//evil.com", "/\evil.com", "https://...", "javascript:...") e descartada e o login segue
   para a pagina padrao. Devolve o caminho (com a query e o hash) ou '' quando nao serve. */

const MAX = 300;
// Letras, numeros e a pontuacao normal de caminho, query e hash. Nada de espaco, aspas, <, >, crase, chaves, barra invertida.
const CARACTERES_OK = /^[A-Za-z0-9\-._~!$&()*+,;=:@%/?#[\]]+$/;
// Controle e barra invertida (o navegador troca "\" por "/" e "/\evil.com" vira "//evil.com")
// eslint-disable-next-line no-control-regex -- faixa de controle de propósito: é exatamente o que se quer barrar
const PROIBIDOS = /[\u0000-\u001f\u007f\\]/;

export function caminhoInternoSeguro(valor) {
    if (typeof valor !== 'string') return '';
    const v = valor.trim();
    if (!v || v.length > MAX || v === '/') return '';
    if (v[0] !== '/' || v[1] === '/' || v[1] === '\\') return '';
    if (PROIBIDOS.test(v) || !CARACTERES_OK.test(v)) return '';
    // %2f%2f, %5c e semelhantes: confere de novo depois de decodificar (uma vez e duas)
    let d = v;
    for (let i = 0; i < 2; i++) {
        try { d = decodeURIComponent(d); } catch (_) { return ''; }
        if (d[0] !== '/' || d[1] === '/' || d[1] === '\\' || PROIBIDOS.test(d)) return '';
    }
    return v;
}
